module.exports = __webpack_public_path__ + "img/france.df2a7096.svg";